import React from 'react';
import ProgressBar from '@/components/ui/ProgressBar';

interface ProgressProps {
	completed: number;
	total: number;
}

export function Progress({ completed = 0, total = 0 }: Readonly<ProgressProps>): JSX.Element {
	const percent = Math.trunc((completed / total) * 100);

	return <ProgressBar percent={percent} style={{ marginBottom: '35px' }} />;
}
